<template>
	<div class="circle">
		<div class="left-tree">
			<Tree :showSwitch='false' title=" " @nodeClick="nodeClick"></Tree>
		</div>
		<div class="right-content">
			<div class="msg-header">
				<span>{{this.searchParams.areaName}}家乡圈</span>
			</div>
			<div class="msg-body" id="chatFrame" ref="chatFrame">
				<div v-if="showMore" class="histroy" @click="getHistoryList">——查看历史消息——</div>
				<div v-else class="no-histroy">没有更多消息了</div>
				<div class="msg-list">
					<div v-for="(item,index) in dataList">
						<div class="isMe" v-if="item.owner" style="text-align: right">
							<p class="item" style="font-size: 14px;color: #666;">{{item.createGmt}}</p>
							<p class="IMname">{{item.author}}</p>
							<div class="" style="display: flex;justify-content: flex-end;">
								<div v-if="item.type==2">
									<!-- :preview-src-list="item.images" -->
									<el-image v-for="(citem,index) in item.imgList" :key="index" style="width: 50px; height: 50px;margin: 0 10px;" :src="citem" :preview-src-list="item.imgList"></el-image>
								</div>
								<video style="width: 300px;height: 200px;" controls="controls" v-else-if="item.type  == 3" :src="item.videos"
								 alt=""></video>
								<div  class="content" v-else-if="item.type  == 4">
									分享了一个地址 <a style="color: red;cursor: pointer;" @click="openMap(item.latitude,item.longitude)">{{item.address}}</a>
								</div>
								<div v-else class="content">{{ item.content|| ''}}</div>
								<el-avatar class="avatar m-right" shape="square" size="medium" :src="item.authorPortrait"></el-avatar>
							</div>
						</div>
						<div class="notMe" v-else>
							<p class="item" style="display: flex;width: 100%;font-size: 14px;color: #666;">{{item.createGmt}}</p>
							<p class="IMname">{{item.author}}</p>
							<div class="" style="display: flex;">
								<el-avatar class="avatar m-right" shape="square" size="medium" :src="item.authorPortrait"></el-avatar>
								<div v-if="item.type==2">
									<el-image v-for="(citem,index) in item.imgList" :key="index" style="width: 50px; height: 50px;margin: 0 10px;" :src="citem" :preview-src-list="item.imgList"></el-image>
								</div>
								<video style="width: 300px;height: 200px;" controls="controls" v-else-if="item.type  == 3" :src="item.videos"
								 alt=""></video>
								<div  class="content" v-else-if="item.type  == 4">
									分享了一个地址 <a style="color: red;cursor: pointer;" @click="openMap(item.latitude,item.longitude)">{{item.address}}</a>
								</div>
								<div v-else class="content">{{ item.content|| ''}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="msg-bottom">
				<div class="icon-tool">
					<span class="icon-font" @click="openImgALert">
						<i class="el-icon-picture"></i>
					</span>
					<span class="icon-font" @click="openMap1">
						<i class="iconfont icondizhi"></i>
					</span>
				</div>
				<el-input class="" style="width:100%" @keydown.native="listen($event)" v-model="content" type="textarea"
				 row="5"></el-input>
				<el-button class="sendBut" @click="sendMsg">发送</el-button>
			</div>
		</div>
		<!-- 图片弹窗 -->
		<el-dialog :visible.sync="showImg" title="选择图片(最多3张)">
			<el-upload
				 ref='uploadImg'
			  class="avatar-uploader"
			  :action="publicAPI.uploadFile"
			  accept="image/png, image/jpeg"
			  :on-success="handleAvatarSuccess"
			  :before-upload="beforeAvatarUpload"
			  :limit="3"
			  list-type="picture-card"
			  :on-remove="handleRemove"
			  :multiple="true">
			  <i class="el-icon-plus avatar-uploader-icon"></i>
			</el-upload>
			<div style="text-align: center;width: 100%">
			  <el-button type="primary"  style="text-align: center" @click="savePic()">分享</el-button>
			</div>
		</el-dialog>
		<!-- 地图弹窗 -->
		<el-dialog title="位置" :visible.sync="mapConfig.mapDialogShow" :append-to-body='true' class="map-dialog" @close="mapConfig.mapInit = true"
		           style="height: 800px;">
		    <div class="map-dialog-container">
		        <div class="map-box">
		            <el-input placeholder="请输入内容" v-model="mapConfig.siteName" @keyup.enter.native="searchSiteName()"
		                      style="position: absolute;top: 10px;left: 10px;z-index: 1">
		                <i slot="append" @click="searchSiteName()" class="el-icon-search"></i>
		            </el-input>
		            <div id="mapContainer" style="width: 100%;height: 400px"></div>
		          </div>
		        <div class="location-box">
		            <span v-if="mapConfig.locBtn">位置坐标:</span>
		            <p v-if="mapConfig.locBtn"><input v-model="mapConfig.position[0]" type="number"> - <input type="number" v-model="mapConfig.position[1]"></p>
		            <el-button v-if="mapConfig.locBtn" type="primary" size="mini" style="margin-left: 20px;" @click="searchPosition(true)">标注</el-button>
		            <el-button v-if="mapConfig.locBtn" type="primary" size="mini" style="margin-left: 20px;" @click="saveSite()">保存</el-button>
		           <div class="" v-if="mapConfig.showSave" style="text-align: center;width: 100%">
		             <el-button type="primary"  style="text-align: center" @click="saveSite()">分享</el-button>
		           </div>
		        </div>
		    </div>
		</el-dialog>
	</div>
</template>

<script>
	import publicAPI from '../../../../api-path/public-api.js'
	import Tree from '../../../../components/Tree/nodeTree';
	import {
		visitsApi
	} from '../../../../api-path/visits-circle.js'
	export default {
		components: {
			Tree
		},
		data() {
			return {
				publicAPI,
				showMore: true,
                userName: localStorage.getItem('p') || '',
                phone: localStorage.getItem('phone') || '',

				searchParams: {
					areaId: '',
					areaName: '',
					page: 0,
					size: 10,
				},
				circleInfo: {
					people: 0
				},
				postInfo: {
					"address": "",
					"areaId": "",
					"content": "",
					"id": "",
					"images": "",
					"isBackstage": true,
					"isGov": true,
					"latitude": 0,
					"longitude": 0,
					"readNum": 0,
					"realUrl": "",
					"title": "",
					"type": "",
					"videos": "",
					authorPortrait:'',
				},
				dataList: [], //消息列表
				// 地图
				mapConfig: {
				    saveCallBack: '',
				    map: '',// 地图实例
				    locBtn:false,
				    mapDialogShow: false, // 地推显示
				    mapInit: true, // 是否初始化map
				    addressLocation: '', // 是否需要返回坐标
				    siteName: '', // 地图查询名称
				    position: [], // 当前坐标
				    key: '', // 保存的值的key
					showSave:false,//是否显示保存按钮
				},
				//选择图片
				showImg:false,
				imgList:[],
				//内容
				content:""
			}
		},
		created() {
			// this.getHistoryList()
		},
		mounted() {
		},
		methods: {
			openImgALert(){
				this.showImg=true;
			},
			nodeClick(node) {
				this.searchParams.areaId = node.id;
				this.searchParams.areaName = node.name;
				this.postInfo.areaId=node.id;
				this.areaId=node.id;
                this.mapConfig.saveCallBack = ()=>{};
				this.searchParams.page=0;
				this.dataList=[]
				this.getHistoryList();
			},
			getHistoryList() {
				if(this.showMore){
					++this.searchParams.page;
				}
				this.$http.get(visitsApi.circleList, {
					params: this.searchParams
				}).then(res => {
					if (res.status == 200) {
						if (res.result.pageList.length != 0) {
							this.showMore = true;
							let result=res.result.pageList.reverse();
							 this.dataList = [...result,...this.dataList];
							 if(this.searchParams.page==1){
								 this.Talk()
							 }
						} else {
							this.showMore = false;
						}
					}
				})
			},
			sendMsg() {
				this.postInfo.owner=true;
				this.postInfo.author=this.userName?this.userName:this.phone?this.phone:'';
				this.postInfo.type='1';
				this.sendPostInfo();
			},
			//滚动条滚到底
			Talk() { 
				this.messagesContainerTimer = setTimeout(() => {
					this.$refs.chatFrame.scrollTop = this.$refs.chatFrame.scrollHeight;
					clearTimeout(this.messagesContainerTimer); // 清理定时器
				}, 0);
				console.log(this.$refs.chatFrame.scrollTop )
				console.log(this.$refs.chatFrame.scrollHeight )
			
			},
			//发送内容
			sendPostInfo(){
				this.postInfo.createGmt=(new Date()).Format('yyyy-MM-dd hh:mm:ss');
				this.postInfo.content=JSON.parse(JSON.stringify(this.content));
				this.$http.post(visitsApi.circleSave,this.postInfo).then(res=>{
					if(res.status==200){
						
						this.$nextTick(()=>{
						  this.$refs.uploadImg.clearFiles();
						})
						this.showImg=false;
						if(this.postInfo.type==2){
							this.postInfo.images.split(',')
						}
						this.postInfo.authorPortrait=JSON.parse(localStorage.getItem('ur')).portrait
						this.dataList.push(this.postInfo);
						this.imgList=[];
						this.content='';
						this.postInfo={
								"address": "",
								"areaId": this.areaId,
								"content": "",
								"id": "",
								"images": "",
								"isBackstage": true,
								"isGov": true,
								"latitude": 0,
								"longitude": 0,
								"readNum": 0,
								"realUrl": "",
								"title": "",
								"type": "",
								"videos": "",
								imgList:[],
								authorPortrait:""
						}
						this.Talk();
					}
				})
			},
			savePic(){
				let imgs=this.imgList.map(item=>{
					return item.url
				});
				this.postInfo.owner=true;
				this.postInfo.author=this.userName?this.userName:this.phone?this.phone:'';
				this.postInfo.imgList=imgs;
				this.postInfo.images=imgs.toString();
				this.postInfo.type='2';
				this.sendPostInfo()
			},
			// 上传图片
			 handleAvatarSuccess(res, file) {
				if(res.status==200){
					this.imgList.push(res.result);
				}
			},
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
				  this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isLt2M;
			}, 
			handleRemove(file, fileList) {
				this.imgList=fileList.map(item=>{
					return item.response.result
				})
			},
			openMap(lat,lng){
				this.mapConfig.position=[lng,lat];
				this.mapConfig.mapDialogShow=true;
				this.mapConfig.showSave=false;
				setTimeout(()=>{
					this.initMap();
				},1000)
			},
			openMap1(){
				this.mapConfig.position=[];
				this.mapConfig.siteName='';
				this.mapConfig.mapDialogShow=true;
				this.mapConfig.showSave=true;
				setTimeout(()=>{
					this.initMap();
				},1000)
			},
			// 初始化地图
			initMap() {
					const _this = this
			    this.mapConfig.map = new AMap.Map('mapContainer', {
			        resizeEnable: true,
			        zoom: 8,
			        viewMode: '2D',
			        zooms: [7, 18]
			    })
				if(this.mapConfig.position){
					AMap.plugin('AMap.Geocoder', function() {
						const geocoder = new AMap.Geocoder({
							city: '0'
						})
						geocoder.getAddress(_this.mapConfig.position, function(status, result) {
							if (status === 'complete' && result.info === 'OK') {	
								_this.mapConfig.siteName = result.regeocode.formattedAddress
								_this.mapConfig.map.setCenter(_this.mapConfig.position)
								_this.mapConfig.map.setZoom(13)
								_this.addMarker(_this.mapConfig.position)
							}
						})
					})
				}
			    this.clickOn()
			},
			
			// map事件绑定
			clickOn() {
			    this.mapConfig.map.on('click', this.showInfoClick);
			},
			
			//  map解绑事件
			clickOff() {
			    this.mapConfig.map.off('click', this.showInfoClick);
			},
			
			// 地址逆查询
			searchSiteName() {
			    const _this = this
			    AMap.plugin('AMap.Geocoder', function() {
			        const geocoder = new AMap.Geocoder({
			            city: '0'
			        })
			        geocoder.getLocation(_this.mapConfig.siteName, function (status, result) {
			            if (status === 'complete' && result.info === 'OK') {
			                const position = [result.geocodes[0].location.lng, result.geocodes[0].location.lat]
			                _this.mapConfig.map.setZoom(13)
			                _this.mapConfig.position = position
			                _this.mapConfig.map.setCenter(position)
			                _this.addMarker(position)
			            }
			        })
			    })
			},
			
			// 坐标查询
			searchPosition() {
			    if (this.mapConfig.position.length !== 2) {
			        return false
			    }
			    const _this = this
			    AMap.plugin('AMap.Geocoder', function() {
			        const geocoder = new AMap.Geocoder({
			            city: '0'
			        })
			        const lnglat = _this.mapConfig.position
			        geocoder.getAddress(lnglat, function(status, result) {
			            if (status === 'complete' && result.info === 'OK') {
			                _this.mapConfig.siteName = result.regeocode.formattedAddress
			                _this.mapConfig.map.setCenter(lnglat)
			                _this.mapConfig.map.setZoom(13)
			                _this.addMarker(lnglat)
			            }
			        })
			    })
			},
			
			// 点击事件
			showInfoClick(e) {
			    this.mapConfig.position = [e.lnglat.lng,e.lnglat.lat]
			    this.searchPosition()
			},
			
			// 添加标记
			addMarker(lnglat) {
			    this.mapConfig.map.clearMap()
			    const marker = new AMap.Marker({
			        position: lnglat,
			        offset: new AMap.Pixel(-15, -35),
			        icon: require('../../../../assets/images/map/position.png')
			    });
			    this.mapConfig.map.add(marker);
			},
			
			// 保存地址
			saveSite() {
				this.postInfo.owner=true;
				this.postInfo.author=this.userName?this.userName:this.phone?this.phone:'';
				this.postInfo.address=this.mapConfig.siteName;
				this.postInfo.longitude=this.mapConfig.position[0];
				this.postInfo.latitude=this.mapConfig.position[1];
				this.postInfo.type='4';
				this.sendPostInfo();
			    this.mapConfig = Object.assign(this.mapConfig, this.$options.data().mapConfig);
			
			},
			//回车禁止换行
			listen (event) {
			    if (event.keyCode === 13) {
			        this.sendSock(5,1) // 发送文本
			        event.preventDefault() // 阻止浏览器默认换行操作
			        return false
			    }
			},
		}
	}
</script>

<style lang="less" scoped>
	.circle {
		margin-left: 10px;
		box-sizing: border-box;
		height: 100%;
		padding: 10px;
		border-radius: 10px;
		background: #fff;
		display: flex;

		.left-tree {
			margin-right: 10px;
			border-right: 1px solid #c1c1c1;
		}

		.right-content {
			flex: 1;
			padding: 10px;
			border: 10px solid #f1f4fb;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.msg-header {
				height: 40px;
				border: 1px solid #ddd;
				border-radius: 5px;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.msg-body {
				flex: 1;
				overflow-y: auto;

				.msg-list {
					// height: calc(100% - 40px);
					// overflow-y: auto;
					.isMe {
						text-align: right;
						margin-top: 5px;
						margin-right: 10px;
						.IMname{
							margin-bottom: 10px;
						}
						.read {
							color: #999999;
						}
						.m-right{
							margin-left: 10px;
						}
						.content {
					
							padding: 10px;
							background: #d8e8f9;
							border-radius: 5px;
							word-wrap: break-word;
							width: auto;
							display: inline-block;
							max-width: 90%;
							position: relative;
							right: 0;
							&:before {
								display: block;
								content: "";
								width: 0;
								height: 0;
								position: absolute;
								right: -6px;
								top: 14px;
								border-top: solid 6px transparent;
								border-left: 6px solid #d8e8f9;
								border-bottom: solid 6px transparent;
							}
							.el-icon-video-camera-solid{
								margin-right: 5px;
								font-size: 18px;
							}
						}
					}
					
					.notMe {
						margin-bottom: 10px;
						text-align: left;
						.IMname{
							margin-bottom: 10px;
						}
					
						.content {
							padding: 10px;
							background: #e8e8e8;
							border-radius: 5px;
							width: auto;
							display: inline-block;
							max-width: 90%;
							word-wrap: break-word;
							position: relative;
							&:before {
								display: block;
								content: "";
								width: 0;
								height: 0;
								position: absolute;
								left: -6px;
								top: 14px;
								border-top: solid 6px transparent;
								border-right: 6px solid #e8e8e8;
								border-bottom: solid 6px transparent;
							}
							.el-icon-video-camera-solid{
								margin-left: 5px;
								font-size: 18px;
							}
						}
					}
					
					.chatFrame {
						padding: 10px;
						width: 100%;
						box-sizing: border-box;
						// min-height: 200px;
						flex: 1;
						overflow-y: auto;
						/*border:1px solid #d3d3d0 ;*/
						border-top: 0;
					
						.MoreNews {
							color: #d3d3d0;
							font-size: 12px;
							margin-bottom: 10px;
							display: inline-block;
					
							&:hover {
								color: #00a0e9;
							}
						}
					
						.imTime {
							text-align: center;
							color: #b8b8b5;
							margin: 10px 0;
							font-size: 14px;
						}
					
						.IMname {
							font-size: 10px;
							margin-bottom: 10px;
						}
					
					}
					
					.controlStrip {
						padding: 5px;
						display: flex;
						align-self: flex-end;
						.text-right {
							i {
								margin: 0 5px;
								font-size: 28px;
					
								&:hover {
									color: #00a0e9;
								}
							}
						}
					}
					
					.sendBut {
						margin: 10px 0;
					}
					
					.m-right {
						margin-right: 10px;
					}
					
					.m-left {
						margin-left: 10px;
					}
					
					.avatar {
						vertical-align: middle;
					
					}
					
					.operation {
						.el-button {
							border: 0;
							padding: 0;
					
							&:hover {
								color: #409EFF;
								background: none !important;
							}
						}
					
					}
				}
			}

			.histroy {
				color: #d3d3d0;
				font-size: 12px;
				height: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
				cursor: pointer;

				&:hover {
					color: #0B70FE;
				}
			}

			.no-histroy {
				color: #d3d3d0;
				font-size: 12px;
				height: 40px;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.msg-bottom {
				text-align: right;

				.icon-tool {
					margin: 10px 0;

					.icon-font {
						margin: 0 10px;
						cursor: pointer;
						>i{
							font-size: 20px;
						}
						&:hover {
							color: #0B70FE;
						}
					}
				}

				.sendBut {
					margin-top: 20px;
				}
			}
		}
	}
</style>
